export class FactureHonorairesGenerationResult {
    transactionCodeNum: number;
    transactionUrl: string;
    erreur: boolean;
    erreurMessage: string;
}